module.exports = __webpack_public_path__ + "img/24-support.5b523d87.svg";